module.exports = __webpack_public_path__ + "img/About_1.28fd6305.svg";